import { get, patch, post } from 'models/shared/helpers/axiosInstance';
import { buildPathWithQueryParams } from 'models/shared/helpers/utils';
import { PaginatedDocuments } from 'models/shared/types/pagination';
import {
	BatchUploadResult,
	ListWhitelistFilters,
	UpdateWhitelistEntryFields,
	WhitelistEntry,
	WhitelistNameEnum,
	WhitelistTypeEnum,
} from '../interfaces/whitelist.interface';

const baseWhitelistPath = '/v1/whitelists';

export const fetchWhitelist = async (
	filters: ListWhitelistFilters,
): Promise<PaginatedDocuments<WhitelistEntry>> => {
	try {
		const res = await get<PaginatedDocuments<WhitelistEntry>>(
			buildPathWithQueryParams(baseWhitelistPath, { ...filters }),
		);
		return res.data;
	} catch (err: any) {
		throw err.response?.data ?? err;
	}
};

export const createWhitelistEntry = async (
	name: WhitelistNameEnum,
	type: WhitelistTypeEnum,
	value: string,
	expiresAt?: string,
): Promise<WhitelistEntry> => {
	try {
		const res = await post<WhitelistEntry>(baseWhitelistPath, {
			name,
			type,
			value,
			expiresAt: expiresAt || undefined,
		});
		return res.data;
	} catch (err: any) {
		throw err.response?.data ?? err;
	}
};

export const updateWhitelistEntry = async (
	id: string,
	fields: UpdateWhitelistEntryFields,
): Promise<WhitelistEntry> => {
	try {
		const res = await patch<WhitelistEntry>(
			`${baseWhitelistPath}/${id}`,
			fields,
		);
		return res.data;
	} catch (err: any) {
		throw err.response?.data ?? err;
	}
};

export const createWhitelistBatchFromFile = async (
	name: WhitelistNameEnum,
	type: WhitelistTypeEnum,
	file: File,
	expiresAt?: string,
): Promise<BatchUploadResult> => {
	try {
		const data = new FormData();
		data.append('name', name);
		data.append('type', type);
		if (expiresAt) data.append('expiresAt', expiresAt);
		data.append('file', file);

		const res = await post<BatchUploadResult>(
			`${baseWhitelistPath}/batch/file`,
			data,
			{
				headers: { 'Content-Type': 'multipart/form-data' },
			},
		);
		return res.data;
	} catch (err: any) {
		throw err.response?.data ?? err;
	}
};
